export const ADMIN_ROLE = "admin";
export const COACH_ROLE = "coach";
export const TRIAL_CRM_ROUTE = "FreeTrialRequests";
export const TRIAL_CRM_PATH = "/free-trial-requests";

export function isAdminRole(role) {
  return role === ADMIN_ROLE;
}

export function isCoachRole(role) {
  return role === COACH_ROLE;
}

export function canAccessRoute(role, routeName) {
  if (isAdminRole(role)) return true;
  return isCoachRole(role) && routeName === TRIAL_CRM_ROUTE;
}

export function signedInLandingPath(role) {
  return isCoachRole(role) ? TRIAL_CRM_PATH : "/";
}

export function safeRedirectPath(value) {
  return typeof value === "string" && /^\/(?!\/)/.test(value) ? value : "";
}
